import Vue from 'vue';
import axios from 'axios';
import get from 'lodash/get';

export default {
  /**
   * get the user profile info.
   *
   * @returns {Promise}
   */
  getProfile() {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    return axios.get(`${BASE_PATH}/users/me`).then(response => response.data);
  },

  /**
   * updates the current user profile
   *
   * @returns {Promise}
   */
  updateProfile(payload) {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    return axios.post(`${BASE_PATH}/users/me/profile`, payload).then(response => response.data);
  },

  /**
   * get the current policy
   *
   * @returns {Promise}
   */
  getPrivacyPolicyKey() {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    return axios
      .get(`${BASE_PATH}/metadata/key/power3_privacy_policy`)
      .then(response => response.data);
  },

  /**
   * get the current terms and condition
   *
   * @returns {Promise}
   */

  getTermsAndConditionsKey() {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    return axios
      .get(`${BASE_PATH}/metadata/key/power3_terms_and_conditions`)
      .then(response => response.data);
  },

  /**
   * get the current news
   *
   * @returns {Promise}
   */

  getNewsKey() {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    return axios.get(`${BASE_PATH}/metadata/key/power3_news`).then(response => response.data);
  },

  /**
   * get the current policy document
   *
   * @returns {Promise}
   */

  getPolicyDocument(latestKey) {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    return axios.get(`${BASE_PATH}/metadata/key/${latestKey}`).then(response => response);
  },

  /**
   * get the current terms and conditions document
   *
   * @returns {Promise}
   */

  getTermsAndConditionDocument(latestKey) {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    return axios.get(`${BASE_PATH}/metadata/key/${latestKey}`).then(response => response);
  },

  /**
   * get the current news document
   *
   * @returns {Promise}
   */

  getNewsDocument(latestKey) {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    return axios.get(`${BASE_PATH}/metadata/key/${latestKey}`).then(response => response);
  }
};
